import { render, staticRenderFns } from "./Receptionist.vue?vue&type=template&id=5e0b9c03&scoped=true&"
import script from "./Receptionist.vue?vue&type=script&lang=js&"
export * from "./Receptionist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b9c03",
  null
  
)

export default component.exports